import { Theme } from '@mui/material'
import React, { memo, PropsWithChildren } from 'react'
import { makeStyles, createStyles } from '@mui/styles'
import { ISpecialInterestRate } from './typings'
import SpecialInterestRateTooltip from './SpecialInterestRateTooltip'

const useStyles = makeStyles<Theme, ISpecialInterestRate>((theme: Theme) =>
  createStyles({
    tooltipContentCls: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      height: '30%',
    },
    innerContentCls: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      height: '70%',
      marginLeft: 30,
      marginBottom: 25,
      [theme.breakpoints.down('md')]: {
        marginLeft: 20,
      },
    },
    toolTipCls: {
      background: ({ isSpecial, themeColors }) =>
        isSpecial ? themeColors?.bgColor : '',
      color: ({ isSpecial, themeColors }) =>
        isSpecial ? themeColors?.color : '',
    },
    specialOfferRateCls: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      flexGrow: 1,
      background: ({ isSpecial, themeColors }) =>
        isSpecial ? themeColors?.bgColor : '',
      color: ({ isSpecial, themeColors }) =>
        isSpecial ? themeColors?.color : '',
      [theme.breakpoints.down('md')]: {
        marginRight: '5px',
        borderRadius: '0 10px 0 0',
      },
    },
    clipCls: {
      height: '120%',
      marginTop: -15,
      marginBottom: -3,
      display: 'flex',

      '&:before': {
        content: '""',
        background: ({ isSpecial, themeColors }) =>
          isSpecial ? themeColors?.color : '',
        height: 15,
        width: 20,
        clipPath: 'polygon(100% 0, 0% 100%, 100% 100%)',
        marginLeft: -50,
        [theme.breakpoints.down('md')]: {
          marginLeft: -40,
        },
      },
    },
  }),
)

const SpecialInterestRateComponent = ({
  children,
  ...props
}: PropsWithChildren<ISpecialInterestRate>) => {
  const { specialOfferRateCls, clipCls, innerContentCls } = useStyles(
    props || { isSpecial: false },
  )

  return (
    <div className={clipCls}>
      <div className={specialOfferRateCls}>
        <SpecialInterestRateTooltip {...props} />
        <div className={innerContentCls}>{children}</div>
      </div>
    </div>
  )
}

export default memo(SpecialInterestRateComponent)
